<template>
<v-menu :value='visible' >
    <v-btn icon
      @click.stop='show'
      slot="activator"><v-icon>{{icon}}</v-icon> {{text}}</v-btn>
    <action-list :appointment='appointment' />
</v-menu>
</template>

<script>
import ActionList from '@/components/appointment/actions/ActionList.vue'
export default {
  name: 'ActionMenu',
  components: { ActionList },
  props: {
    appointment: { type: Object, default: () => { return {} } },
    icon: { type: String, default: 'more_vert' },
    text: { type: String, default: '' },
    exclude: { type: Array, default: () => { return [] } }
  },
  data () {
    return {visible: false}
  },
  methods: {
    show () {
      this.visible = false
      window.setTimeout(() => { this.visible = true }, 100)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ActionMenu.vue?6822ed01